import PropTypes from 'prop-types';
import React, { Component } from 'react';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EditorState = function () {
  // TODO: use immutable.js
  function EditorState() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var selectionStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var selectionEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : selectionStart;
    classCallCheck(this, EditorState);
    this.content = content;
    this.selection = {
      start: selectionStart,
      end: selectionEnd
    };
  }

  createClass(EditorState, [{
    key: 'isContentEmpty',
    value: function isContentEmpty() {
      return this.content.length <= 0;
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var _selection = this.selection,
          start = _selection.start,
          end = _selection.end;
      var word = this.content.substring(start, end);
      return {
        word: word,
        start: start,
        end: end
      };
    }
  }, {
    key: 'isSelectionMultiline',
    value: function isSelectionMultiline(editorState) {
      var _getSelection = this.getSelection(),
          word = _getSelection.word;

      return word.trim().includes('\n');
    }
  }], [{
    key: 'equals',
    value: function equals(e1, e2) {
      return e1.content.localeCompare(e2.content) === 0 && e1.selection.start === e2.selection.start && e1.selection.end === e2.selection.end;
    }
  }, {
    key: 'insertAt',
    value: function insertAt(editorState) {
      var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var selectAfterInsert = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var content = editorState.content.substring(0, start) + text + editorState.content.substring(end);

      if (selectAfterInsert) {
        end = start + text.length;
      } else {
        start = end = content.length;
      }

      return new EditorState(content, start, end);
    }
  }, {
    key: 'toggleBlockStyle',
    value: function toggleBlockStyle(editorState, leftTag, rightTag) {
      return EditorState.toggleInlineStyle(editorState, leftTag + '\n', '\n' + rightTag);
    }
  }, {
    key: 'toggleInlineStyle',
    value: function toggleInlineStyle(editorState, leftTag, rightTag) {
      var _editorState$selectio = editorState.selection,
          start = _editorState$selectio.start,
          end = _editorState$selectio.end;
      var prefix = editorState.content.substring(0, start);
      var inner = editorState.content.substring(start, end);
      var suffix = editorState.content.substring(end);
      var isTaggedOutside = prefix.endsWith(leftTag) && suffix.startsWith(rightTag);
      var isTaggedInside = inner.startsWith(leftTag) && inner.endsWith(rightTag);

      if (isTaggedOutside) {
        prefix = prefix.substring(0, prefix.length - leftTag.length);
        suffix = suffix.substring(rightTag.length);
        start -= leftTag.length;
        end -= leftTag.length;
      } else if (isTaggedInside) {
        inner = inner.substring(leftTag.length, inner.length - rightTag.length);
        end -= leftTag.length;
      } else {
        inner = leftTag + inner + rightTag;
        start += leftTag.length;
        end += leftTag.length;
      }

      return new EditorState(prefix + inner + suffix, start, end);
    }
  }, {
    key: 'toggleMultilineStyle',
    value: function toggleMultilineStyle(editorState, leftTag, rightTag) {
      var _editorState$selectio2 = editorState.selection,
          start = _editorState$selectio2.start,
          end = _editorState$selectio2.end;
      var prefix = editorState.content.substring(0, start);
      var inner = editorState.content.substring(start, end);
      var suffix = editorState.content.substring(end);

      if (!editorState.isSelectionMultiline()) {
        // single line version also handles affixes inside the selection
        return EditorState.toggleInlineStyle(editorState, leftTag, rightTag);
      }

      var lines = inner.split('\n');
      var areTagged = lines.reduce(function (state, line) {
        return state && line.startsWith(leftTag) && line.endsWith(rightTag);
      }, true);
      lines = lines.map(function (line) {
        if (areTagged) {
          end -= leftTag.length;
          return line.substring(leftTag.length, line.length - rightTag.length);
        }

        end += leftTag.length;
        return leftTag + line + rightTag;
      });
      return new EditorState(prefix + lines.join('\n') + suffix, start, end);
    }
  }, {
    key: 'toggleNumberedStyle',
    value: function toggleNumberedStyle(editorState) {
      var _editorState$selectio3 = editorState.selection,
          start = _editorState$selectio3.start,
          end = _editorState$selectio3.end;
      var prefix = editorState.content.substring(0, start);
      var inner = editorState.content.substring(start, end);
      var suffix = editorState.content.substring(end);

      if (!editorState.isSelectionMultiline()) {
        // TODO:
        // check that selection is in a numebred list,
        // and call the single line version with correct prefix
        // on each lines (1., 2., 3., etc.)
        return EditorState.toggleInlineStyle(editorState, '1. ', '');
      }

      var lines = inner.split('\n'); // check lines are prefixed incrementally

      var tagNumber = 1;
      var areTagged = lines.reduce(function (state, line) {
        var tagStr = tagNumber + '. ';
        ++tagNumber;
        return state && line.startsWith(tagStr);
      }, true);
      tagNumber = 1;
      lines = lines.map(function (line) {
        var tagStr = tagNumber + '. ';
        ++tagNumber;

        if (areTagged) {
          end -= tagStr.length;
          return line.substring(tagStr.length, line.length);
        }

        end += tagStr.length;
        return tagStr + line;
      });
      return new EditorState(prefix + lines.join('\n') + suffix, start, end);
    }
  }]);
  return EditorState;
}();

var Editor = function (_Component) {
  inherits(Editor, _Component);

  function Editor(props) {
    classCallCheck(this, Editor);

    var _this = possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));

    _this.handleEditorStateChange = function (e) {
      var newEditorState = new EditorState(e.target.value, e.target.selectionStart, e.target.selectionEnd);

      _this.props.onEditorStateChange(newEditorState);
    };

    _this.handleKeyDown = function (e) {
      if ((e.ctrlKey || e.metaKey) && _this.props.onCommandKeyDown) {
        _this.props.onCommandKeyDown(e);
      }
    };

    _this.ref = props.forwardRef || React.createRef();
    _this.handleEditorStateChange = _this.handleEditorStateChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  createClass(Editor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ref.current.selectionStart = this.props.editorState.selection.start;
      this.ref.current.selectionEnd = this.props.editorState.selection.end;
      !!this.props.autofocus && this.ref.current.focus();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // NOTE:
      // 1) Allows us to set DOM selection state from the editorState prop.
      // 2) Avoid setSelectionRange as this sets the selection direction to
      //    "forward" by default, which prevents us from selecting with the
      //    keyboard in reverse direction.
      this.ref.current.selectionStart = this.props.editorState.selection.start;
      this.ref.current.selectionEnd = this.props.editorState.selection.end;
      this.ref.current.focus();
    } // We need to prevent renders when the editor state is not changing as
    // the textarea will focus every update, and that is not desired behavior.

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !EditorState.equals(this.props.editorState, nextProps.editorState);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement('textarea', {
        ref: this.ref,
        placeholder: this.props.placeholder,
        value: this.props.editorState.content,
        onChange: this.handleEditorStateChange,
        onSelect: this.handleEditorStateChange,
        onKeyDown: this.handleKeyDown,
        style: this.props.style,
        className: this.props.className
      });
    }
  }]);
  return Editor;
}(Component);

Editor.propTypes = {
  autofocus: PropTypes.bool,
  editorState: PropTypes.instanceOf(EditorState).isRequired,
  onCommandKeyDown: PropTypes.func,
  onEditorStateChange: PropTypes.func.isRequired,
  forwardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })])
};
var Editor$1 = React.forwardRef(function (props, ref) {
  return React.createElement(Editor, _extends({}, props, {
    forwardRef: ref
  }));
});

function Preview(props) {
  return React.createElement('div', {
    style: props.style,
    className: props.className,
    dangerouslySetInnerHTML: {
      __html: props.markdownRenderFn(props.editorState.content)
    }
  });
}

Preview.propTypes = {
  editorState: PropTypes.instanceOf(EditorState).isRequired,
  markdownRenderFn: PropTypes.func.isRequired
};
export { Editor$1 as Editor, EditorState, Preview };